export default function ServicesSection() {
  return (
    <section className="relative w-full bg-background-100 pt-[140px] pb-[160px]">
      <div className="absolute" style={{ left: "10%", top: "100px" }}>
        <span
          className="block text-[11px] uppercase tracking-[0.25em] leading-[1.4] text-foreground-600"
          style={{ fontFamily: "var(--font-label)" }}
        >
          PRACTICE
          <br />
          DOMAINS
        </span>
      </div>

      <div className="text-center mb-[140px]">
        <h2
          className="text-[64px] font-light tracking-[-0.02em] text-foreground-950"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          Engineering Philosophy
        </h2>
        <div className="mx-auto mt-[60px] w-[60%] h-px bg-foreground-950/8" />
      </div>

      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

          <div className="rounded-[28px] bg-primary-500 p-14 flex flex-col justify-between min-h-[480px]">
            <div className="w-16 h-16 rounded-full bg-foreground-800/20 flex items-center justify-center">
              <span
                className="text-[22px] font-bold text-white uppercase"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                A
              </span>
            </div>
            <div>
              <h3
                className="text-[32px] font-bold text-white leading-[1.15] mb-4"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                Scalable System
                <br />
                Design
              </h3>
              <p
                className="text-[14px] text-foreground-400 leading-relaxed"
                style={{ fontFamily: "var(--font-body)" }}
              >
                We architect systems that grow with confidence. Every component is designed for modularity, testability, and long-term adaptability so that complexity never becomes a bottleneck.
              </p>
            </div>
          </div>

          <div className="rounded-[28px] relative overflow-hidden min-h-[480px] flex flex-col justify-between">
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: `url(https://readdy.ai/api/search-image?query=Abstract%20mineral%20texture%20in%20muted%20rust%20sand%20and%20stone%20tones%20smooth%20organic%20stratification%20with%20soft%20geometric%20variations%20no%20human%20figures%20no%20products%20no%20identifiable%20objects%20purely%20abstract%20natural%20texture%20with%20warm%20earthy%20color%20palette&width=600&height=480&seq=card-mineral-tk-2026&orientation=portrait)`,
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/30" />
            <div className="relative z-10 p-14">
              <div className="inline-flex items-center h-9 px-[18px] rounded-full bg-black/60 gap-2">
                <div className="w-3 h-3 rounded-full bg-white/70" />
                <span
                  className="text-[11px] font-medium text-white tracking-[0.1em] uppercase whitespace-nowrap"
                  style={{ fontFamily: "var(--font-label)" }}
                >
                  FOCUS
                </span>
              </div>
            </div>
            <div className="relative z-10 p-14 pt-0">
              <h3
                className="text-[32px] font-bold text-white leading-[1.15]"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                iOS-Centric
                <br />
                Engineering
              </h3>
            </div>
          </div>

          <div className="rounded-[28px] bg-transparent border border-background-300/60 p-14 flex flex-col justify-between min-h-[480px]">
            <div>
              <h3
                className="text-[40px] font-normal text-foreground-950 leading-[1.1] mb-5"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                Performance
                <br />
                &amp; Stability
              </h3>
              <p
                className="text-[14px] text-foreground-600 leading-relaxed mb-8"
                style={{ fontFamily: "var(--font-body)" }}
              >
                High performance and rock-solid stability are not afterthoughts — they are foundational to our engineering approach. We optimize every layer of the stack to ensure responsive, dependable experiences.
              </p>
            </div>
            <div className="flex justify-center">
              <div
                className="w-[200px] h-[200px] bg-cover bg-center"
                style={{
                  backgroundImage: `url(https://readdy.ai/api/search-image?query=Abstract%203D%20rendered%20gyroid%20form%20in%20matte%20clay%20material%20with%20soft%20studio%20lighting%20minimalist%20sculptural%20organic%20geometric%20shape%20warm%20neutral%20beige%20tones%20clean%20background%20no%20human%20figures%20no%20products%20purely%20decorative%20abstract%20object&width=400&height=400&seq=gyroid-tk-2026&orientation=squarish)`,
                }}
              />
            </div>
          </div>

        </div>
      </div>

      <div className="h-[100px]" />
    </section>
  );
}